import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { apiError, showPopup } from '../helpers'
import { getCurrentServerUrl } from '../helpers/axios'
import { captureException } from '../helpers/Sentry'
import { logout } from './auth'

const moduleName = 'tools'

export const SEND_INFO_TO_JIVO_CHAT = `${moduleName}/SEND_INFO_TO_JIVO_CHAT`

export function sendInfoToJivoChat(payload) {
  return {
    type: SEND_INFO_TO_JIVO_CHAT,
    payload
  }
}

const delay = (time) => new Promise((resolve) => setTimeout(resolve, time))

const sendInfoToJivoChatSagaTime = function*() {
  yield call(delay, 1000)

  yield call(sendInfoToJivoChatSaga)
}

const sendInfoToJivoChatSaga = function*() {
  try {
    const { properties, interaction, profile } = yield select((state) => state)

    let clientName = ''
    let propertyId = null

    let propertiesExists = !!properties.entities[0]

    if (propertiesExists) {
      const entity = properties.entities[0]
      propertyId = entity.id
      clientName = entity.name
    }

    let ticketId = null

    const interactionData = interaction.data

    if (!!interactionData && !!interactionData.number) {
      ticketId = interactionData.number
    }

    if (!!window.jivo_api) {
      const response = profile

      const contactInfo = {
        name: `${response.firstName} ${response.lastName} [${clientName}]`,
        email: response.email,
        phone: response.mobilePhone,
        description: `lang: ${response.language}, position: ${response.position}`
      }

      setContactInfoToJivo(contactInfo)

      let userToken = {
        personEmail: response.email,
        propertyId: propertyId,
        productId: 'c811b080-6ddd-4bd5-998c-3e893899f56b'
      }

      if (!!ticketId) {
        userToken.ticketId = ticketId
      }

      window.jivo_api.setUserToken(JSON.stringify(userToken))

      let customData = [
        {
          title: 'Client',
          content: clientName,
          link: `${getCurrentServerUrl()}property?id=${propertyId}`
        },
        {
          title: 'Description',
          content: `lang: ${response.language}, position: ${response.position}`,
          link: null
        }
      ]

      if (ticketId) {
        customData.push({
          title: 'Ticket',
          content: ticketId,
          link: `${getCurrentServerUrl()}app/ticket?id=${ticketId}`
        })
      }

      window.jivo_api.setCustomData(customData)
    }
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      if (code === 2) {
        yield put(logout())
      }
    } else {
      captureException(e)
    }
  }
}

export const saga = function*() {
  yield all([takeLatest(SEND_INFO_TO_JIVO_CHAT, sendInfoToJivoChatSagaTime)])
}

export const setContactInfoToJivo = ({ name, email, phone }) => {
  window.jivo_api.setContactInfo({
    name: name,
    email: email,
    phone: phone
  })
}
